// NOTICE: KAPTION-INTEGRATION
// smart-assignment.MANUAL.1 — the manual trigger.
import ApiClient from './ApiClient';

class KaptionSmartAssignment extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  resolve(conversationId) {
    return this.post(`${conversationId}/smart_assign`);
  }
}

export default new KaptionSmartAssignment();
